import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { UsersHttpRepository } from "../repository";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";

const usersRepository = new UsersHttpRepository();

export function useFetchUser(id: string | undefined) {
  const navigate = useNavigate();
  const query = useQuery({
    queryKey: ["user", id],
    queryFn: () => usersRepository.fetchOne(id ?? ""),
    enabled: !!id,
  });

  useEffect(() => {
    if (query.error) {
      navigate(ROUTES.USERS);
    }
  }, [query.error, navigate]);

  return {
    user: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
